import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

const VocabularyWordPlaceholder = () => {
  return (
    <LoadingBox
      width={Math.floor(Math.random() * 200) + 60}
      height={36}
      borderRadius="1,5x"
    />
  )
}

export default VocabularyWordPlaceholder
